import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';

const NessebarProject = () => {
  const { t } = useTranslation();

  const stats = [
    { label: t('projectPower'), value: '300 KWp' },
    { label: t('projectType'), value: t('projectTypeStatic') },
    { label: t('projectYear'), value: '2023' },
  ];

  const galleryImages = [
    '/assets/projects/dzhanny1.jpg',
    '/assets/projects/dzhanny2.jpg',
    '/assets/projects/dzhanny3.jpg',
    '/assets/projects/dzhanny4.jpg',
    '/assets/projects/dzhanny5.jpg',
    '/assets/projects/dzhanny6.jpg',
  ];

  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const handleImageClick = (index) => {
    setPhotoIndex(index);
    setIsOpen(true);
  };

  return (
    <div className="pt-24 pb-16 px-6 text-[#173861]">
      <button
        onClick={() => window.history.back()}
        className="mb-6 bg-[#50A444] text-white px-4 py-2 rounded hover:bg-green-700 transition"
      >
        ← {t('back')}
      </button>

      <h1 className="text-4xl font-bold text-center mb-10">{t('nessebarTitle')}</h1>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl mx-auto mb-12">
        {stats.map((stat, idx) => (
          <div key={idx} className="bg-[#F1FDF3] rounded-xl p-6 text-center shadow-md">
            <div className="text-2xl font-bold">{stat.value}</div>
            <div className="text-md mt-2">{stat.label}</div>
          </div>
        ))}
      </div>


      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {galleryImages.map((src, idx) => (
          <img
            key={idx}
            src={src}
            alt={`Nessebar Project ${idx + 1}`}
            className="w-full h-64 object-cover rounded-xl shadow-md hover:scale-105 transition-transform duration-300 cursor-pointer"
            onClick={() => handleImageClick(idx)}
          />
        ))}
      </div>

       {isOpen && (
        <Lightbox
          open={isOpen}
          close={() => setIsOpen(false)}
          index={photoIndex}
          slides={galleryImages.map((src) => ({ src }))}
          styles={{ container: { backgroundColor: 'rgba(0, 0, 0, 0.9)' } }}
        />
      )}
    </div>
  );
};

export default NessebarProject;
